export default __webpack_public_path__ + "static/media/ecopupPreview.f7a0a217.webp";